export default "__VITE_ASSET__b88c94e3__"